import clsx from 'clsx'

interface LogoProps {
  collapsed?: boolean
  size?: 'sm' | 'md' | 'lg'
  className?: string
  light?: boolean
}

function LogoIcon({ className = 'w-9 h-9' }: { className?: string }) {
  return (
    <svg viewBox="0 0 512 512" className={className}>
      <defs>
        <linearGradient id="logoBg" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#1e40af"/>
          <stop offset="100%" stopColor="#1e3a8a"/>
        </linearGradient>
      </defs>
      <rect width="512" height="512" rx="108" fill="url(#logoBg)"/>
      <ellipse cx="256" cy="100" rx="170" ry="40" fill="none" stroke="white" strokeWidth="24" opacity="0.3"/>
      <ellipse cx="256" cy="170" rx="135" ry="35" fill="none" stroke="white" strokeWidth="24" opacity="0.45"/>
      <ellipse cx="256" cy="235" rx="100" ry="28" fill="none" stroke="white" strokeWidth="24" opacity="0.6"/>
      <ellipse cx="256" cy="295" rx="65" ry="22" fill="none" stroke="white" strokeWidth="24" opacity="0.75"/>
      <ellipse cx="256" cy="350" rx="35" ry="16" fill="none" stroke="white" strokeWidth="24" opacity="0.9"/>
      <circle cx="256" cy="410" r="16" fill="#facc15"/>
    </svg>
  )
}

function FunnelIcon({ className = 'w-14', light = false }: { className?: string; light?: boolean }) {
  const stroke = light ? 'white' : '#1e3a8a'
  return (
    <svg viewBox="0 0 512 512" className={className}>
      <ellipse cx="256" cy="140" rx="160" ry="45" fill="none" stroke={stroke} strokeWidth="28"/>
      <ellipse cx="256" cy="220" rx="100" ry="32" fill="none" stroke={stroke} strokeWidth="28"/>
      <ellipse cx="256" cy="290" rx="45" ry="20" fill="none" stroke={stroke} strokeWidth="28"/>
      <circle cx="256" cy="350" r="20" fill="#facc15"/>
    </svg>
  )
}

const sizeMap = {
  sm: { icon: 'w-8 h-8', text: 'text-lg', gap: 'gap-2' },
  md: { icon: 'w-10 h-10', text: 'text-xl', gap: 'gap-3' },
  lg: { icon: 'w-14 h-14', text: 'text-3xl', gap: 'gap-3' },
}

export default function Logo({ collapsed = false, size = 'md', className = '', light = false }: LogoProps) {
  const s = sizeMap[size]

  return (
    <div className={clsx('flex items-center', s.gap, className)}>
      <LogoIcon className={clsx(s.icon, 'flex-shrink-0 rounded-xl')} />
      {!collapsed && (
        <span className={clsx(s.text, 'font-bold')}>
          <span className={light ? 'text-white' : 'text-primary-900'}>S<span className="dotted-i">ı</span>spol<span className="dotted-i">ı</span></span>
        </span>
      )}
    </div>
  )
}

function AuthLogo() {
  return (
    <div className="flex items-center gap-1.5 justify-center mb-10">
      <FunnelIcon className="w-12" />
      <span className="text-[28px] font-bold text-brand-900">
        S<span className="dotted-i">ı</span>spol<span className="dotted-i">ı</span>
      </span>
    </div>
  )
}

export { LogoIcon, FunnelIcon, AuthLogo }
